export const convertDuration = (duration: number) => {
  // Round to nearest integer to handle decimal values
  const totalSeconds = Math.round(duration);

  const hours = Math.floor(totalSeconds / 3600);
  const minutes = Math.floor((totalSeconds % 3600) / 60);
  const seconds = Math.floor(totalSeconds % 60)
    .toString()
    .padStart(2, "0");

  if (hours > 0) {
    return `${hours}:${minutes.toString().padStart(2, "0")}:${seconds}`;
  }
  return `${minutes.toString().padStart(2, "0")}:${seconds}`;
};
